import React from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Linking,
} from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { navigate } from "../../../../../../navigation/RootNavigation";

const MANAGE_DEPOSIT_URL = "https://www.tenancydepositscheme.com/log-in/";

const ActiveDepositsComponent = ({
  data = [],
  totalAmount,
  openflow_id,
}) => {
  return (
    <View style={styles.container}>
      {/* Title */}
      <Text style={styles.title}>Active Deposits</Text>
      <Text style={styles.subtitle}>
        Deposits related to this tenancy will appear below.
      </Text>

      {/* Card Wrapper */}
      <View style={styles.card}>
        {/* Header */}
        <View style={styles.headerRow}>
          <Text style={[styles.headerCell, { flex: 1 }]}>ID</Text>
          <Text style={[styles.headerCell, { flex: 1 }]}>AMOUNT</Text>
          <Text style={[styles.headerCell, { flex: 1 }]}>STATUS</Text>
          <Text style={[styles.headerCell, { flex: 1.5 }]}>SUBMITTED ON</Text>
          <Text style={[styles.headerCell, { flex: 2, textAlign: "right" }]}>
            ACTIONS
          </Text>
        </View>

        {/* Rows */}
        {data.map((item, index) => {
          const PAIDCOND =
            item.status !== "SAVED" &&
            item.status !== "pending" &&
            item.status !== "draft";

          const hasCertificate = !!item?.dpc_file_path;

          return (
            <View key={index} style={styles.dataRow}>
              {/* ID */}
              <Text style={[styles.dataCell, { flex: 1 }]}>
                {item.id || "N/A"}
              </Text>

              {/* Amount */}
              <Text style={[styles.dataCell, { flex: 1 }]}>
                {item.amount}
              </Text>

              {/* STATUS */}
              <View style={[styles.statusCell, { flex: 1 }]}>
                <View style={styles.statusBadge}>
                  <Text style={styles.statusText}>{item.status}</Text>
                </View>
              </View>

              {/* Submitted On */}
              <TouchableOpacity style={[styles.dataCell, { flex: 1.5 }]}>
                <Text style={styles.dateLink}>{item.submittedOn}</Text>
              </TouchableOpacity>

              {/* ACTIONS */}
              <View style={styles.actionCell}>
                {PAIDCOND && (
                  <>
                    <TouchableOpacity
                      style={styles.actionBtnPrimary}
                      onPress={() =>
                        window.open(MANAGE_DEPOSIT_URL, "_blank")
                      }
                    >
                      <Text style={styles.actionBtnText}>Manage</Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      style={[
                        styles.actionBtnPrimary,
                        !hasCertificate && { opacity: 0.5 },
                      ]}
                      disabled={!hasCertificate}
                      onPress={() => {
                        if (hasCertificate)
                          window.open(item.dpc_file_path, "_blank");
                      }}
                    >
                      <Text style={styles.actionBtnText}>
                        {hasCertificate ? "Download" : "N/A"}
                      </Text>
                    </TouchableOpacity>
                  </>
                )}

                {!hasCertificate && (
                  <TouchableOpacity
                    style={styles.actionBtnSecondary}
                    onPress={() =>
                      navigate("RegisterDeposit", { id: openflow_id })
                    }
                  >
                    <MaterialCommunityIcons
                      name="pencil"
                      size={18}
                      color="#fff"
                    />
                    <Text style={styles.continueText}>
                      {item.id ? "Continue" : "Edit"}
                    </Text>
                  </TouchableOpacity>
                )}
              </View>
            </View>
          );
        })}
      </View>

      {/* TOTAL */}
      <View style={styles.totalRow}>
        <Text style={styles.totalLabel}>TOTAL</Text>
        <Text style={styles.totalAmount}>{totalAmount}</Text>
      </View>
    </View>
  );
};

export default ActiveDepositsComponent;

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 20,
    shadowColor: "#000",
    shadowOpacity: 0.06,
    shadowOffset: { width: 0, height: 4 },
    shadowRadius: 10,
    elevation: 3,
    marginTop: 10,
    width: "100%",
  },
  title: {
    fontSize: 18,
    fontWeight: "700",
    color: "#8c3cc2",
  },
  subtitle: {
    marginTop: 8,
    marginBottom: 20,
    color: "#7b7b7b",
    fontSize: 14,
  },

  /* Card wrapper */
  card: {
    backgroundColor: "#fff",
    borderRadius: 10,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#e6e6e6",
    elevation: 2,
  },

  /* Header */
  headerRow: {
    flexDirection: "row",
    backgroundColor: "#f4f4f4",
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderBottomWidth: 1,
    borderColor: "#e0e0e0",
  },
  headerCell: {
    fontWeight: "700",
    color: "#555",
    fontSize: 13,
  },

  /* Rows */
  dataRow: {
    flexDirection: "row",
    paddingVertical: 16,
    paddingHorizontal: 14,
    borderBottomWidth: 1,
    borderColor: "#f2f2f2",
    alignItems: "center",
  },
  dataCell: {
    fontSize: 15,
    color: "#222",
  },

  /* Status pill */
  statusCell: { justifyContent: "center" },
  statusBadge: {
    backgroundColor: "#dff5d8",
    paddingHorizontal: 14,
    paddingVertical: 6,
    borderRadius: 50,
    alignSelf: "flex-start",
  },
  statusText: {
    color: "#2e7d32",
    fontWeight: "700",
    fontSize: 13,
  },

  /* Submitted date link */
  dateLink: {
    color: "#5c2dd5",
    textDecorationLine: "underline",
    fontWeight: "500",
  },

  /* ACTIONS */
  actionCell: {
    flex: 2,
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 10,
  },

  actionBtnPrimary: {
    backgroundColor: "#2962ff",
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 8,
    minWidth: 90,
    alignItems: "center",
  },
  actionBtnText: {
    color: "#fff",
    fontWeight: "600",
  },

  actionBtnSecondary: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#5E35B1",
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 10,
    gap: 6,
    minWidth: 100,
    justifyContent: "center",
  },
  continueText: {
    color: "#fff",
    fontWeight: "700",
  },

  /* Total Row */
  totalRow: {
    backgroundColor: "#9b59c3",
    paddingVertical: 18,
    paddingHorizontal: 20,
    marginTop: 20,
    borderRadius: 6,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  totalLabel: {
    color: "#fff",
    fontWeight: "800",
    fontSize: 16,
  },
  totalAmount: {
    color: "#fff",
    fontWeight: "800",
    fontSize: 16,
  },
});
